import BackIcon from "./chevron-left.svg";

export default BackIcon;
